import { InfluencerNewProfileHeaderV2, useAllTiktokSimilarInfluencersQuery } from '@anytag/graphql';
import {
  TK_ACCOUNT_IS_CREATED_LESS_THAN_1_DAY,
  DEFAULT_SIMILAR_INFLUENCERS_LIMITATION
} from '@anytag/shared-constants';
import { useAllAvailableCountryOptions } from '@anytag/shared-hooks';
import { InfluencerSelectedAccountInfo } from '../../types';
import { InfluencerProfileSimilarInfluencers, InfluencerProfileSimilarInfluencersProps } from '../shared';

interface InfluencerTiktokProfileSimilarInfluencersProps {
  className?: string;
  socialAccount: InfluencerSelectedAccountInfo;
  influencerProfile: InfluencerNewProfileHeaderV2;
}

export const InfluencerTiktokProfileSimilarInfluencers = ({
  socialAccount,
  influencerProfile: { country }
}: InfluencerTiktokProfileSimilarInfluencersProps) => {
  const { allAvailableCountryOptions } = useAllAvailableCountryOptions();
  const { data, error, loading } = useAllTiktokSimilarInfluencersQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: allAvailableCountryOptions.findIndex((option) => option.label === country.name) === -1,
    variables: { genders: [], accountId: socialAccount.id, limit: DEFAULT_SIMILAR_INFLUENCERS_LIMITATION.PROFILE.FETCH }
  });

  const similarInfluencers: InfluencerProfileSimilarInfluencersProps['data'] =
    data?.allTiktokSimilarInfluencers?.map((infl) => ({
      id: infl.id,
      name: infl.name,
      avatar: infl.avatar,
      gender: infl.gender,
      countryName: infl.country.name,
      socialAccountId: infl.socialAccountId,
      followers: infl.socialAccountFollowers,
      engagementRate: infl.socialAccountEngagementFollowersRate
    })) || [];

  return (
    <InfluencerProfileSimilarInfluencers
      loading={loading}
      socialMedia="TIKTOK"
      data={similarInfluencers}
      wrapperText={
        error?.message.includes(TK_ACCOUNT_IS_CREATED_LESS_THAN_1_DAY)
          ? 'Similar accounts will be shown in 1-2 days after being added to AnyTag'
          : undefined
      }
    />
  );
};
